import styled from "styled-components";
import {LiveCasinoGridItemTitleDefaultBox} from "./live-casino-grid-item-title.default.box";

export const LiveCasinoGridItemTitleSIBox = styled(LiveCasinoGridItemTitleDefaultBox)`
    font-size: 1.3em;
    letter-spacing: 0.48px;
    ${({theme}) => theme.font.presets.medium};
`;
